import Color from 'color';
import type { PropsWithChildren } from 'react';
import React from 'react';
import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';

interface ICoverageSubgroupTitle {
  sx?: BoxProps['sx'];
}

const CoverageSubgroupTitle = ({
  sx,
  children,
}: PropsWithChildren<ICoverageSubgroupTitle>) => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) =>
          Color(theme.palette.background.default)
            .lighten(theme.palette.mode === 'dark' ? 0.5 : 0.05)
            .toString(),
        width: '100%',
        paddingLeft: '1.35rem',
        display: 'block',
        paddingTop: '0.5rem',
        paddingBottom: '0.5rem',
        fontStyle: 'italic',
        fontWeight: 600,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default CoverageSubgroupTitle;
